import {TranslationKeyGlobal} from '../../keys'
import {TranslationResource} from '../../TranslationType'

export const TRANSLATION_GLOBAL_EN: TranslationResource<TranslationKeyGlobal> = {
  translation: {
    'global:accept': 'Accept',
    'global:accepted': 'Accepted',
    'global:activate': 'Activate',
    'global:activated': 'Activated',
    'global:add': 'Add',
    'global:addNew': 'Add New',
    'global:addNow': 'Add Now',
    'global:additionalDataModalButton': 'Go to Edit Profile',
    'global:additionalDataModalDescription':
      'Before you continue, please register your email address in the edit profile.',
    'global:additionalDataModalTitle': 'Additional Data Required',
    'global:all': 'All',
    'global:allContents': 'All Contents',
    'global:allDone': 'All Done!',
    'global:allTime': 'All time',
    'global:amount': 'Amount',
    'global:and': 'and',
    'global:apply': 'Apply',
    'global:areYouSure': 'Are you sure?',
    'global:back': 'Back',
    'global:backTo': 'Back to {{page}}',
    'global:bad': 'Bad',
    'global:basicPrice': 'Basic Price',
    'global:beta': 'Beta',
    'global:buy': 'Buy',
    'global:by': 'By',
    'global:cancel': 'Cancel',
    'global:cart': 'Cart',
    'global:change': 'Change',
    'global:changesSaved': 'Changes have been saved',
    'global:charCount': '{{count}}/{{max}}',
    'global:chat': 'Chat',
    'global:chatTheCreator': 'Chat the Creator',
    'global:checkoutPayment': 'Payment',
    'global:chosen': 'Chosen',
    'global:city': 'City',
    'global:clearAll': 'Clear All',
    'global:close': 'Close',
    'global:comment': 'Comment',
    'global:communities': 'Communities',
    'global:complete': 'Complete',
    'global:confirm': 'Confirm',
    'global:confirmation': 'Confirmation',
    'global:confirmed': 'Confirmed',
    'global:congratulations': 'Congratulations!',
    'global:connectionInterrupted': 'Connection interrupted',
    'global:content': 'Content',
    'global:continue': 'Continue',
    'global:copyLink': 'Copy Link',
    'global:createnickname': 'Create Nickname',
    'global:createnicknameDesc':
      'Create a nickname to protect your privacy. You can change this later.',
    'global:createnicknameFail': "There's a problem when sending your data",
    'global:creators': 'Creators',
    'global:currency': 'Currency',
    'global:current': 'Current',
    'global:date': 'Date',
    'global:dateFormat': '{{hour}}h {{minute}}m',
    'global:dateOfBirth': 'Date of Birth',
    'global:day': 'Day',
    'global:day_plural': 'Days',
    'global:days': '{{day}} days',
    'global:delete': 'Delete',
    'global:deleteContent': 'Delete Content',
    'global:deleted': 'Deleted',
    'global:description': 'Description',
    'global:discount': 'Discount',
    'global:download': 'Download',
    'global:downloadApp': 'Download App',
    'global:duplicate': 'Duplicate',
    'global:duration': 'Duration',
    'global:edit': 'Edit',
    'global:editContent': 'Edit Content',
    'global:email': 'Email',
    'global:emailNew': 'New Email',
    'global:events': 'Events',
    'global:failed': 'Failed',
    'global:failedLoad': 'Failed to Load',
    'global:faq': 'FAQ',
    'global:fileName': 'File Name View',
    'global:filter': 'Filter',
    'global:flipVertical': 'Flip Vertical',
    'global:forUser': 'For {{nickname}}',
    'global:fotoyu': 'FotoYu',
    'global:fotoyuAdmin': 'Fotoyu Admin',
    'global:fototree': 'FotoTree',
    'global:fotoyuSupportTeam': 'FotoYu support team:',
    'global:free': 'Free',
    'global:from': 'From',
    'global:generateThumbnail':
      'Generating thumbnail... please come back later.',
    'global:good': 'Good',
    'global:guideline': 'Guidelines',
    'global:here': 'here',
    'global:high': 'High',
    'global:hires': 'Hi-Res',
    'global:hour': 'Hour',
    'global:host': 'Host',
    'global:howItWorks': 'How It Works',
    'global:iAgree': 'I Agree',
    'global:iBanking': 'i-Banking',
    'global:iChooseThis': 'I choose this',
    'global:idr': 'IDR',
    'global:invoiceCopied': 'Invoice successfully copied',
    'global:isRated': 'Rated',
    'global:isThisYou': 'Is This You?',
    'global:itsMe': 'Yeah, it’s me',
    'global:kycModalInfo': 'The next step will turn on your camera.',
    'global:kycModalSubtitle':
      'Activate RoboYu on the mobile app to search for your documentation with face recognition technology.',
    'global:lastCertainDays': 'Last {{days}} days',
    'global:later': 'Later',
    'global:less': 'less',
    'global:limitedAccess': 'Limited Access',
    'global:limitedAccessDesc': 'Does not meet minimum age requirement.',
    'global:link': 'Link',
    'global:linkCopied': 'Link successfully copied',
    'global:live': 'Live',
    'global:location': 'Location',
    'global:login': 'Login',
    'global:loading': 'Loading...',
    'global:logout': 'Log Out',
    'global:maintenanceEnd': 'until <date>{{date}}</date>',
    'global:maintenanceStart': 'on <date>{{date}}</date>',
    'global:masonryView': 'Masonry View',
    'global:medium': 'Medium',
    'global:menu': 'Menu',
    'global:messageError': 'Oops... something unexpected happened',
    'global:message': 'Message',
    'global:messageError_code-400': 'Format data is not valid',
    'global:messageError_code-401':
      'The access token that is currently used is no longer valid',
    'global:messageError_code-403':
      'You are prohibited from accessing this feature',
    'global:messageError_code-404': 'Page not found',
    'global:messageError_code-408': '$t(global:messageError_timeout)',
    'global:messageError_code-409': 'Resource Conflict: ID has been used',
    'global:messageError_no-connection': 'No Internet Connection',
    'global:messageError_timeout': 'Connection Timeout',
    'global:messageError-execute':
      'Error occured while executing action. Please try again.',
    'global:minute': 'Minute',
    'global:mobileNumber': 'Mobile Number',
    'global:mobileNumberNew': 'New Mobile Number',
    'global:month': 'Month',
    'global:month_april': 'April',
    'global:month_august': 'August',
    'global:month_december': 'December',
    'global:month_february': 'February',
    'global:month_january': 'January',
    'global:month_july': 'July',
    'global:month_june': 'June',
    'global:month_march': 'March',
    'global:month_may': 'May',
    'global:month_november': 'November',
    'global:month_october': 'October',
    'global:month_september': 'September',
    'global:more': 'more',
    'global:name': 'Name',
    'global:needHelp': 'Need Help?',
    'global:next': 'Next',
    'global:nickname': 'Nickname',
    'global:no': 'No',
    'global:notes': 'Notes',
    'global:notification': 'Notification',
    'global:notMe': 'Not Me',
    'global:notRegistered': 'Not Registered',
    'global:numberCopied': 'Number successfully copied',
    'global:off': 'Off',
    'global:ok': 'OK',
    'global:on': 'On',
    'global:open': 'Open',
    'global:options': 'Options',
    'global:other': 'Other',
    'global:package': 'Package',
    'global:packages': 'Packages',
    'global:password': 'Password',
    'global:passwordConfirm': 'Confirm Password',
    'global:phoneNumber': 'Phone Number',
    'global:photo': 'Photo',
    'global:places': 'Places',
    'global:pleaseTryAgain': 'Please try again in {{countdown}}.',
    'global:pleaseWait': 'Please wait...',
    'global:processed': 'Processed',
    'global:profile': 'Profile',
    'global:publish': 'Publish',
    'global:purchaseDate': 'Purchase date: {{purchased_at}}',
    'global:recentSearch': 'Recent Searches',
    'global:recover': 'Recover',
    'global:refreshPage': 'Refresh',
    'global:register': 'Register',
    'global:reject': 'Reject',
    'global:rejected': 'Rejected',
    'global:remove': 'Remove',
    'global:removeAll': 'Remove All',
    'global:reply': 'Reply',
    'global:report': 'Report',
    'global:reportContent': 'Report Content',
    'global:reportFail': 'Report Failed',
    'global:reportFailMessage':
      "There's a problem when sending your report. Please try again.",
    'global:reportReason': 'Select a reason:',
    'global:reportSuccess': 'Report Successful!',
    'global:reportSuccessMessage':
      'Thankyou for your participation. We will process your report.',
    'global:requested': 'Requested',
    'global:reset': 'Reset',
    'global:retry': 'Retry',
    'global:revision': 'Revision',
    'global:rotate': 'Rotate Content',
    'global:rotateLeft': 'Rotate Left',
    'global:rotateRight': 'Rotate Right',
    'global:rp': 'IDR',
    'global:save': 'Save',
    'global:saveChanges': 'Save Changes',
    'global:search': 'Search',
    'global:seeMore': 'See More',
    'global:select': 'Select',
    'global:selectAll': 'Select All',
    'global:selectedCount': '{{count}} Selected',
    'global:selectVideo': 'Select video to upload',
    'global:send': 'Send',
    'global:settings': 'Settings',
    'global:share': 'Share',
    'global:shareContent': 'Share Content',
    'global:shareContentFailed':
      'Unable to share {{type}} at this time. Please try again later.',
    'global:signUp': 'Sign Up',
    'global:similarAccount': 'Possible Duplicate Accounts',
    'global:skip': 'Skip',
    'global:sorry': 'Sorry!',
    'global:sort': 'Sort',
    'global:standard': 'Standard',
    'global:start': 'Start',
    'global:stop': 'Stop',
    'global:stay': 'Stay Here',
    'global:submit': 'Submit',
    'global:success': 'Successful!',
    'global:sure': "Yes, I'm sure",
    'global:tapToRetry': 'Tap to Retry',
    'global:time': 'Time',
    'global:title': 'Title',
    'global:to': 'To',
    'global:to_direction': 'To',
    'global:today': 'Today',
    'global:tomorrow': 'Tomorrow',
    'global:transferATM': 'Transfer ATM',
    'global:transferMiniATM': 'Transfer Mini ATM',
    'global:tryAgain': 'Try Again',
    'global:tryRefresh': 'Try to refresh the page.',
    'global:type': 'Type',
    'global:unfollow': 'Unfollow',
    'global:upgrade': 'Upgrade',
    'global:upgradeStatus': 'Upgrade Status',
    'global:upload': 'Upload',
    'global:uploadedImage': 'Uploaded Image',
    'global:uploadVideo': 'Upload Video',
    'global:uploadVideoOptional': 'Upload Video (Optional)',
    'global:username': 'Username',
    'global:validationMaxLength':
      'This form requires maximum number of {{count}} character',
    'global:validationMaxLength_plural':
      'This form requires maximum number of {{count}} characters',
    'global:validationMaxPrice': 'Content maximum price is {{price}}',
    'global:validationMinLength':
      'This form requires at least {{count}} character',
    'global:validationMinLength_plural':
      'This form requires at least {{count}} characters',
    'global:validationMinPrice': 'Content minimum price is {{price}}',
    'global:validationRequired': 'This form is required',
    'global:verify': 'Verify',
    'global:video': 'Video',
    'global:waitingAdmin': 'Waiting Admin Approval',
    'global:whatsapp': 'WhatsApp',
    'global:with': 'With',
    'global:yes': 'Yes',
    'global:yesDelete': 'Yes, Delete',
    'global:yesImSure': "I'm Sure",
    'global:yesterday': 'Yesterday',
    'global:yourResponse': 'Your response',
    'global:yuser': 'Yuser',
    'global:yuser_plural': 'Yusers',
  },
}
